import Navigation from "@/components/Navigation";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Helmet } from "react-helmet";
import ChineseZodiacIcon from "@/components/ChineseZodiacIcon";

const HoroscopoPerro = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Horóscopo Chino Perro - Predicciones Diarias | Midstino</title>
        <meta name="description" content="Horóscopo chino del signo Perro. Predicciones diarias de amor, trabajo y salud para los nacidos en los años del Perro." />
      </Helmet>
      
      <Navigation />
      
      <main className="container mx-auto px-4 pt-24 pb-12">
        <Card className="max-w-4xl mx-auto">
          <CardContent className="p-8">
            <div className="text-center mb-6">
              <div className="flex justify-center mb-4">
                <ChineseZodiacIcon animal="perro" size={96} />
              </div>
              <h1 className="text-3xl font-bold mb-2">Perro</h1>
              <p className="text-muted-foreground">Años: 1934, 1946, 1958, 1970, 1982, 1994, 2006, 2018, 2030</p>
            </div>

            <Tabs defaultValue="hoy" className="w-full">
              <TabsList className="grid w-full grid-cols-3">
                <TabsTrigger value="hoy">Hoy</TabsTrigger>
                <TabsTrigger value="manana">Mañana</TabsTrigger>
                <TabsTrigger value="semana">Esta Semana</TabsTrigger>
              </TabsList>

              <TabsContent value="hoy" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu lealtad inquebrantable y honestidad están especialmente valoradas hoy, Perro. Tu devoción sincera crea vínculos profundos y duraderos. Las parejas se sentirán seguras y amadas.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu sentido de justicia y ética laboral brillan hoy. Tu confiabilidad te hace indispensable en el equipo. Es momento de defender tus valores y principios con convicción.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu bienestar está ligado a tu sentido de propósito. Actividades que sirvan a otros o contribuyan al bien común te energizarán. El ejercicio en compañía te beneficiará especialmente.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="manana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mañana será perfecto para demostrar tu compromiso con gestos significativos. Tu sinceridad tocará el corazón de tu pareja. Los solteros atraerán personas que valoran la autenticidad.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu integridad te abrirá puertas importantes mañana. Situaciones que requieren honestidad y coraje moral se resolverán favorablemente. Tu reputación de confiabilidad crecerá.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu energía estará equilibrada. Actividades al aire libre con amigos o familia nutrirán tu espíritu social. La conexión con otros fortalecerá tu bienestar general.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="semana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Una semana de profundización en la confianza y compromiso. Tu lealtad incondicional fortalecerá los lazos con tu pareja. Las relaciones basadas en valores compartidos florecerán.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Esta semana tu sentido de justicia será tu guía. Tu honestidad y dedicación serán reconocidas y recompensadas. Mantén tus principios firmes incluso ante desafíos.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mantén el equilibrio entre servir a otros y cuidarte a ti mismo esta semana. Tu naturaleza protectora no debe olvidar tu propio bienestar. Prioriza el autocuidado regularmente.
                  </p>
                </div>
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default HoroscopoPerro;
